import axios from "axios";
import Vue from "vue";

export const state = {
  accounts: [],
  saveStatus: "",
  chartOfAccounts: "",
  mappedAccounts: "",
  mappingAccounts: "",
  expenseAccounts: "",
  assetAccounts: "",
  liabilityAccounts: "",
  equityAcctounts: "",
  revenueAccounts: "",
  allTransAccounts: "",
  entries: "",
  balancesheet: "",
  incomestate: "",
};

export const getters = {
  getAccounts: (state) => state.accounts,
  getChartOfAccounts: (state) => state.chartOfAccounts,
  getMappedAccounts: (state) => state.mappedAccounts,
  getMappAccounts: (state) => state.mappingAccounts,
  SaveStatus: (state) => state.saveStatus,
  getExpenseAccounts: (state) => state.expenseAccounts,
  getAssetAccounts: (state) => state.assetAccounts,
  getLiabilityAccounts: (state) => state.liabilityAccounts,
  getEquityAccounts: (state) => state.equityAccounts,
  getRevenueAccounts: (state) => state.revenueAccounts,
  getAllTransAccounts: (state) => state.allTransAccounts,
  getBalancesheet: (state) => state.balancesheet,
  Journalentries: (state) => state.entries,
  getIncomeState: (state) => state.incomestate,
};

export const mutations = {
  SET_ACCOUNT(state, newValue) {
    state.accounts = newValue;
  },
  SET_TRANS_ACCOUNT(state, newValue) {
    state.allTransAccounts = newValue;
  },
  SET_ASSET_ACCOUNT(state, newValue) {
    state.assetAccounts = newValue;
  },
  SET_LIABILITY_ACCOUNT(state, newValue) {
    state.liabilityAccounts = newValue;
  },
  SET_EQUITY_ACCOUNT(state, newValue) {
    state.equityAccounts = newValue;
  },
  SET_REVENUE_ACCOUNT(state, newValue) {
    state.revenueAccounts = newValue;
  },
  SET_EXPENSE_ACCOUNT(state, newValue) {
    state.expenseAccounts = newValue;
  },
  SET_CHART(state, newValue) {
    state.chartOfAccounts = newValue;
  },
  SET_MAPPED_CHART(state, newValue) {
    state.mappedAccounts = newValue;
  },
  SET_MAPPING_ACCOUNT(state, newValue) {
    state.mappingAccounts = newValue;
  },
  SET_JOURNAL_ENTRIES(state, newValue) {
    state.entries = newValue;
  },
  SET_BALANCESHEET(state, newValue) {
    state.balancesheet = newValue;
  },
  SET_INCOMESTATE(state, newValue) {
    state.incomestate = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.saveStatus = newValue;
  },
  pushNotification(state, payload) {
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};

export const actions = {
  addAccount({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("accounts", payload)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Account Added Successfully",
        };
        dispatch("fetchAccounts");
        dispatch("fetchChartOfAccounts");
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occuired",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  mapAccount({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("mapAccount", payload)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Account Mapped Successfully",
        };
        dispatch("fetchMappedAccounts");
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occuired",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  submitJournalEntry({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("j_entries", payload)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Journal Entry Added Successfully",
        };
        dispatch("fetchJournalEntries");
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occuired",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  printBalanceSheetDoc({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios({
      url: "/print_balance_sheet",
      method: "post",
      data: payload,
      responseType: "blob",
    })
      .then((response) => {
        commit("SET_SAVE_STATUS", false);
        // Create a new Blob object using the response data
        const file = new Blob([response.data], {
          type: "application/pdf",
        });

        // Create a URL for the file
        const fileURL = URL.createObjectURL(file);

        // Open the PDF in a new tab
        const newWindow = window.open(fileURL);

        // Wait for the file to load before triggering the print dialog
        if (newWindow) {
          newWindow.onload = function() {
            newWindow.focus();
            newWindow.print();
          };
        }
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  printIncomeStateDoc({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios({
      url: "/print_income_statement",
      method: "post",
      data: payload,
      responseType: "blob",
    })
      .then((response) => {
        commit("SET_SAVE_STATUS", false);
        // Create a new Blob object using the response data
        const file = new Blob([response.data], {
          type: "application/pdf",
        });

        // Create a URL for the file
        const fileURL = URL.createObjectURL(file);

        // Open the PDF in a new tab
        const newWindow = window.open(fileURL);

        // Wait for the file to load before triggering the print dialog
        if (newWindow) {
          newWindow.onload = function() {
            newWindow.focus();
            newWindow.print();
          };
        }
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  fetchBalancesheet({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("balance_sheet", payload)
      .then((response) => {
        commit("SET_BALANCESHEET", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occuired While Fetching Accounts",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchIncomeState({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("income", payload)
      .then((response) => {
        commit("SET_INCOMESTATE", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occuired While Fetching Accounts",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchAccounts({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("accounts")
      .then((response) => {
        commit("SET_ACCOUNT", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occuired While Fetching Accounts",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchAssets({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("assets_accounts")
      .then((response) => {
        commit("SET_ASSET_ACCOUNT", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occuired While Fetching Asset Accounts",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchLiabilities({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("liability_accounts")
      .then((response) => {
        commit("SET_LIABILITY_ACCOUNT", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occuired While Fetching Liability Accounts",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchEquity({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("equity_accounts")
      .then((response) => {
        commit("SET_EQUITY_ACCOUNT", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occuired While Fetching Equity Accounts",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchRevenue({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("revenue_accounts")
      .then((response) => {
        commit("SET_REVENUE_ACCOUNT", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occuired While Fetching Revenue Accounts",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchTransAccounts({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("transaction_accounts")
      .then((response) => {
        commit("SET_TRANS_ACCOUNT", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occuired While Fetching Revenue Accounts",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchJournalEntries({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("j_entries")
      .then((response) => {
        commit("SET_JOURNAL_ENTRIES", response.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occuired While Fetching Entries",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchMappAccounts({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("accountsAapping")
      .then((response) => {
        commit("SET_MAPPING_ACCOUNT", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occuired While Fetching Accounts",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchChartOfAccounts({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("chartOfAccounts")
      .then((response) => {
        commit("SET_CHART", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occuired While Fetching Chart Of Accounts",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchMappedAccounts({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("mapAccount")
      .then((response) => {
        commit("SET_MAPPED_CHART", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occuired While Fetching Mapping Accounts",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchExpenseAccounts({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get("expense_account")
      .then((response) => {
        commit("SET_EXPENSE_ACCOUNT", response.data.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occuired While Fetching Expense Accounts",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
};
